import type { IBrowserDictionaryApi } from '@/types/proxy';

export class BrowserDictionaryItem {
    id: number;
    name: string;

    constructor(data: IBrowserDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
    }
}
